/* src/app/front-layout/calendar/year-four-cal/year-four-cal.component.css */
:host {
  --lp-blue: #0077b6;
  --lp-blue-dark: #005f92;
  --lp-blue-light: #00a8e8;
  --lp-gold: #ffbf00;
  --lp-white: #ffffff;
  --lp-off-white: #f8fbff;
  --lp-text: #1a2b3c;
  --lp-text-light: #4a6070;
}
@keyframes lp-fadeUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes lp-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes lp-floatA {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-18px) rotate(4deg);
  }
}
@keyframes lp-floatB {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-12px) rotate(-3deg);
  }
}
@keyframes lp-pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(255, 191, 0, 0.5);
  }
  50% {
    box-shadow: 0 0 0 14px rgba(255, 191, 0, 0);
  }
}
.lp-reveal {
  opacity: 0;
  transform: translateY(36px);
  transition: opacity 0.7s ease, transform 0.7s ease;
}
.lp-reveal.lp-visible {
  opacity: 1;
  transform: translateY(0);
}
.lp-hero {
  min-height: 100vh;
  background:
    linear-gradient(
      135deg,
      var(--lp-blue) 0%,
      #004f80 60%,
      #003050 100%);
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
  padding: 100px 5% 60px;
}
.hero-bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.12;
  background: var(--lp-gold);
  pointer-events: none;
}
.hero-bg-shape.s1 {
  width: 500px;
  height: 500px;
  top: -120px;
  right: -100px;
  animation: lp-floatA 7s ease-in-out infinite;
}
.hero-bg-shape.s2 {
  width: 280px;
  height: 280px;
  bottom: 60px;
  left: -60px;
  animation: lp-floatB 9s ease-in-out infinite;
}
.hero-bg-shape.s3 {
  width: 160px;
  height: 160px;
  bottom: 200px;
  right: 25%;
  animation: lp-floatA 6s ease-in-out infinite reverse;
}
.hero-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
}
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 191, 0, 0.2);
  border: 1px solid rgba(255, 191, 0, 0.5);
  color: var(--lp-gold);
  padding: 6px 16px;
  border-radius: 50px;
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 24px;
  animation: lp-fadeUp 0.6s ease 0.2s both;
}
.hero-badge::before {
  content: "\2605";
}
.lp-hero h1 {
  font-size: clamp(2.4rem, 4vw, 3.6rem);
  color: var(--lp-white);
  line-height: 1.15;
  margin-bottom: 20px;
  font-size: 50px;
  animation: lp-fadeUp 0.7s ease 0.35s both;
}
.lp-hero h1 em {
  color: var(--lp-gold);
  font-style: normal;
}
.lp-hero p {
  color: rgba(255, 255, 255, 0.78);
  font-size: 1.5rem;
  line-height: 1.75;
  margin-bottom: 36px;
  animation: lp-fadeUp 0.7s ease 0.5s both;
}
.hero-btns {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  font-size: 1.5rem;
  animation: lp-fadeUp 0.7s ease 0.65s both;
}
.lp-btn-primary {
  background: var(--lp-gold);
  color: var(--lp-text);
  padding: 14px 32px;
  border-radius: 50px;
  font-weight: 700;
  font-size: 1.5rem;
  text-decoration: none;
  cursor: pointer;
  transition: transform 0.25s, box-shadow 0.25s;
  display: inline-block;
}
.lp-btn-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(255, 191, 0, 0.55);
  color: var(--lp-text);
}
.lp-btn-secondary {
  border: 2px solid rgba(255, 255, 255, 0.5);
  color: var(--lp-white);
  padding: 14px 32px;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1.5rem;
  text-decoration: none;
  cursor: pointer;
  transition: background 0.25s, border-color 0.25s;
  display: inline-block;
}
.lp-btn-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: white;
  color: var(--lp-white);
}
.hero-visual {
  animation: lp-fadeUp 0.8s ease 0.4s both;
  display: flex;
  justify-content: center;
}
.hero-card {
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  padding: 36px;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  width: 100%;
  max-width: 380px;
}
.hero-card h3 {
  color: var(--lp-gold);
  font-size: 2.5rem;
  margin-bottom: 24px;
}
.subject-pill {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 12px 16px;
  margin-bottom: 10px;
  transition: background 0.2s, transform 0.2s;
  cursor: default;
}
.subject-pill:hover {
  background: rgba(255, 255, 255, 0.16);
  transform: translateX(6px);
}
.pill-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pill-label {
  color: white;
  font-weight: 500;
  font-size: 1.5rem;
}
.pill-label small {
  display: block;
  color: rgba(255, 255, 255, 0.55);
  font-size: 1rem;
  font-weight: 400;
}
.lp-stats {
  background: var(--lp-white);
  padding: 60px 5%;
}
.lp-stats-inner {
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  text-align: center;
}
.lp-stat-item {
  padding: 24px 16px;
}
.lp-stat-number {
  font-size: 4rem;
  color: var(--lp-blue);
  font-weight: 900;
  line-height: 1;
}
.lp-stat-number span {
  color: var(--lp-gold);
}
.lp-stat-label {
  color: var(--lp-text-light);
  margin-top: 8px;
  font-size: 2rem;
  font-weight: 500;
}
.lp-subjects,
.lp-features,
.lp-benefits,
.lp-steps {
  padding: 90px 5%;
}
.lp-section-tag {
  display: inline-block;
  background: rgba(0, 119, 182, 0.1);
  color: var(--lp-blue);
  padding: 5px 14px;
  border-radius: 50px;
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 14px;
}
.lp-section-title {
  font-size: clamp(2rem, 3.5vw, 2.8rem);
  color: var(--lp-text);
  line-height: 1.2;
  margin-bottom: 14px;
}
.lp-section-title em {
  color: var(--lp-blue);
  font-style: normal;
}
.lp-section-title.lp-white {
  color: var(--lp-white);
}
.lp-section-sub {
  color: var(--lp-text-light);
  font-size: 1.5rem;
  line-height: 1.7;
  max-width: 560px;
}
.lp-centered {
  text-align: center;
}
.lp-centered .lp-section-sub {
  margin: 0 auto;
}
.lp-subjects {
  background: var(--lp-off-white);
}
.lp-subjects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 24px;
  max-width: 1400px;
  margin: 50px auto 0;
}
.lp-subject-card {
  background: var(--lp-white);
  border-radius: 20px;
  padding: 32px 24px;
  border-top: 4px solid transparent;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s, box-shadow 0.3s;
  position: relative;
  overflow: hidden;
}
.lp-subject-card::after {
  content: "";
  position: absolute;
  inset: 0;
  background:
    linear-gradient(
      135deg,
      rgba(0, 119, 182, 0.04),
      transparent);
  opacity: 0;
  transition: opacity 0.3s;
}
.lp-subject-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 16px 40px rgba(0, 119, 182, 0.15);
}
.lp-subject-card:hover::after {
  opacity: 1;
}
.lp-subject-card.c1 {
  border-color: var(--lp-blue);
}
.lp-subject-card.c2 {
  border-color: #00a8e8;
}
.lp-subject-card.c3 {
  border-color: var(--lp-gold);
}
.lp-subject-card.c4 {
  border-color: #ff6b6b;
}
.lp-subject-card.c5 {
  border-color: #7c5cbf;
}
.lp-s-icon {
  margin-bottom: 16px;
  display: block;
  line-height: 1;
}
.lp-subject-card h3 {
  font-size: 2rem;
  margin-bottom: 10px;
  color: var(--lp-text);
}
.lp-subject-card p {
  color: var(--lp-text-light);
  font-size: 1.5rem;
  line-height: 1.65;
}
.lp-features {
  background: var(--lp-white);
}
.lp-features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  max-width: 1000px;
  margin: 50px auto 0;
}
.lp-feature-card {
  border-radius: 18px;
  padding: 30px 24px;
  background: var(--lp-off-white);
  border: 1px solid rgba(0, 119, 182, 0.1);
  transition: transform 0.3s, border-color 0.3s;
}
.lp-feature-card:hover {
  transform: translateY(-5px);
  border-color: var(--lp-blue);
}
.lp-feature-icon {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background:
    linear-gradient(
      135deg,
      var(--lp-blue),
      var(--lp-blue-light));
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  box-shadow: 0 6px 18px rgba(0, 119, 182, 0.3);
}
.lp-feature-card h3 {
  font-weight: 700;
  margin-bottom: 8px;
  font-size: 2rem;
}
.lp-feature-card p {
  color: var(--lp-text-light);
  font-size: 1.5rem;
  line-height: 1.65;
}
.lp-benefits {
  background: var(--lp-blue);
  position: relative;
  overflow: hidden;
}
.lp-benefits::before {
  content: "";
  position: absolute;
  inset: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.04'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.lp-benefits-tag {
  background: rgba(255, 191, 0, 0.2) !important;
  color: var(--lp-gold) !important;
}
.lp-benefits-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  max-width: 800px;
  margin: 50px auto 0;
}
.lp-benefit-item {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: background 0.3s, transform 0.3s;
  position: relative;
  z-index: 1;
}
.lp-benefit-item:hover {
  background: rgba(255, 255, 255, 0.14);
  transform: scale(1.02);
}
.lp-b-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  background: var(--lp-gold);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.lp-benefit-item h4 {
  color: var(--lp-white);
  font-weight: 700;
  margin-bottom: 4px;
}
.lp-benefit-item p {
  color: rgba(255, 255, 255, 0.68);
  font-size: 1.5rem;
  line-height: 1.6;
}
.lp-steps {
  background: var(--lp-off-white);
}
.lp-steps-row {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  max-width: 860px;
  margin: 60px auto 0;
  position: relative;
}
.lp-steps-row::before {
  content: "";
  position: absolute;
  top: 34px;
  left: calc(16.66% + 20px);
  right: calc(16.66% + 20px);
  height: 3px;
  background:
    linear-gradient(
      to right,
      var(--lp-blue),
      var(--lp-gold));
}
.lp-step {
  flex: 1;
  text-align: center;
  padding: 0 20px;
  position: relative;
}
.lp-step-num {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  background: var(--lp-white);
  border: 3px solid var(--lp-blue);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  font-weight: 900;
  color: var(--lp-blue);
  margin: 0 auto 20px;
  position: relative;
  z-index: 1;
  transition:
    background 0.3s,
    color 0.3s,
    transform 0.3s;
}
.lp-step:hover .lp-step-num {
  background: var(--lp-blue);
  color: var(--lp-white);
  transform: scale(1.1);
}
.lp-step h3 {
  font-weight: 700;
  margin-bottom: 8px;
  font-size: 1.5rem;
}
.lp-step p {
  color: var(--lp-text-light);
  font-size: 1.2rem;
  line-height: 1.6;
}
@media (max-width: 768px) {
  nav {
    padding: 0 4%;
  }
  .nav-logo {
    font-size: 1.1rem;
  }
  .hero-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .hero-visual {
    display: none;
  }
  .lp-stats-inner {
    grid-template-columns: repeat(2, 1fr);
  }
  .lp-features-grid {
    grid-template-columns: 1fr;
  }
  .lp-benefits-grid {
    grid-template-columns: 1fr;
  }
  .lp-steps-row {
    flex-direction: column;
    align-items: center;
    gap: 24px;
  }
  .lp-steps-row::before {
    display: none;
  }
}
.spacer-min {
  width: 10px;
}
.hero-section {
  width: 100%;
  min-height: 100vh;
  background: #fcfcfc;
  display: flex;
  align-items: center;
  margin-top: 50px;
  padding: 40px 20px;
}
.hero-container {
  width: 100%;
  max-width: 1600px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 60px;
  align-items: center;
  z-index: 1;
}
.hero-content {
  max-width: 1600px;
  width: 100%;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: fadeInUp 0.8s ease-out;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.exam-badge {
  display: inline-block;
  background: #ffc83b;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  padding: 12px 24px;
  border-radius: 15px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #000000;
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-align: center;
}
.hero-title {
  font-size: 50px;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 25px;
  text-align: center;
  color: #0077b6;
  text-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}
.hero-subtitle {
  max-width: 1200px;
  font-size: 16px;
  font-weight: 500;
  margin-top: 25px;
  margin-bottom: 10px;
  opacity: 0.95;
  color: #000000;
  letter-spacing: 1px;
  text-align: center;
  padding: 0 20px;
}
.hero-ctas {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  flex-wrap: wrap;
  gap: 10px;
}
.exam-modes {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 20px;
}
.mode-tag {
  background: #fcfcfc;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  padding: 10px 20px;
  border-radius: 10px;
  font-size: 16px;
  color: black;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.3);
  text-align: center;
}
.cta-button {
  background: #0077b6;
  color: #ffffff;
  padding: 14px 45px;
  font-size: 18px;
  font-weight: 700;
  border: none;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin: 5px;
  text-align: center;
  min-width: 250px;
  justify-content: center;
}
.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.3);
}
.info-p {
  font-size: 16px;
  color: #0077b6;
  font-weight: 600;
}
.offers-strip {
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 12px 22px;
  background:
    linear-gradient(
      135deg,
      #fff7e0,
      #ffe8b3);
  border: 1px dashed #ffbf00;
  border-radius: 30px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.08);
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
}
.strong {
  font-size: 18px;
  font-weight: 600;
  color: #0077b6;
}
.offers-text {
  font-size: 15px;
  font-weight: 600;
  color: #333;
  letter-spacing: 0.3px;
  text-align: center;
}
.offers-claim-btn {
  background: #0077b6;
  color: #fff;
  border: none;
  padding: 10px 22px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 6px 16px rgba(255, 107, 53, 0.35);
  white-space: nowrap;
}
.offers-claim-btn:hover {
  transform: translateY(-2px);
  background: #005a8c;
  box-shadow: 0 8px 22px rgba(255, 107, 53, 0.45);
}
.mock-categories {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
  background: #fcfcfc;
  padding: 40px 20px;
}
.mock-categories h3 {
  font-size: 40px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 50px;
  color: #0077b6;
}
.test-cards-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;
}
.exam-card {
  background: white;
  border-radius: 12px;
  padding: 35px 30px;
  box-shadow: 0 4px 20px rgba(0, 119, 182, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  position: relative;
  border-top: 5px solid #0077b6;
}
.exam-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 30px rgba(0, 119, 182, 0.2);
}
.exam-card-top {
  margin-bottom: 25px;
}
.exam-title {
  font-size: 28px;
  font-weight: 700;
  color: #0077b6;
  margin-bottom: 15px;
  line-height: 1.2;
}
.exam-info-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}
.exam-info-row {
  display: flex;
  align-items: center;
  font-size: 15px;
  color: #555;
  flex-wrap: wrap;
  gap: 8px;
}
.info-label {
  font-weight: 600;
  color: #333;
  min-width: 70px;
}
.info-content {
  color: #666;
}
.delivery-modes {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}
.delivery-badge {
  background: #e8f4f8;
  color: #0077b6;
  padding: 4px 12px;
  border-radius: 15px;
  font-size: 13px;
  font-weight: 600;
}
.exam-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 25px;
}
.action-btn {
  padding: 14px 24px;
  border: none;
  border-radius: 25px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: center;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.action-btn-book {
  background: #0077b6;
  color: white;
}
.action-btn-book:hover {
  background: #005a8c;
  transform: scale(1.02);
}
.action-btn-download {
  background: white;
  color: #0077b6;
  border: 2px solid #0077b6;
}
.action-btn-download:hover {
  background: #0077b6;
  color: white;
  transform: scale(1.02);
}
.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
}
.btn-icon svg {
  width: 100%;
  height: 100%;
  fill: currentColor;
}
.centers-section {
  padding: 30px 20px;
  background: #fcfcfc;
  width: 100%;
}
.centers-grid {
  margin: 20px auto;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 320px));
  gap: 30px;
  justify-content: center;
  padding: 0 20px;
}
.center-card {
  width: 100%;
  max-width: 320px;
  position: relative;
  height: 120px;
  border-radius: 15px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}
.center-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 20px 50px rgba(0, 119, 182, 0.2);
}
.center-bg {
  position: absolute;
  inset: 0;
  background: #0077b6;
  transition: transform 0.4s ease;
}
.center-card:hover .center-bg {
  transform: scale(1.1);
}
.center-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 15px;
  color: white;
}
.center-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: white;
}
.center-exams {
  font-size: 14px;
  margin-bottom: 8px;
  opacity: 0.9;
}
.benefits-section {
  padding: 100px 40px;
  background:
    linear-gradient(
      135deg,
      #f8fafc 0%,
      #e0f2fe 100%);
}
.benefits-container {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
}
.benefits-content h2 {
  font-size: 42px;
  font-weight: 800;
  color: #0077b6;
  margin-bottom: 20px;
  line-height: 1.2;
}
.benefits-subtitle {
  font-size: 16px;
  color: #0077b6;
  font-weight: 600;
  margin-bottom: 15px;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.benefits-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  margin-top: 40px;
}
.benefit-card {
  background: white;
  padding: 25px;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.benefit-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0, 119, 182, 0.15);
}
.benefit-icon {
  width: 45px;
  height: 45px;
  min-width: 45px;
  background:
    linear-gradient(
      135deg,
      #0077b6,
      #00b4d8);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: white;
}
.benefit-text {
  font-size: 15px;
  font-weight: 600;
  color: #334155;
  line-height: 1.5;
}
.benefits-image-wrapper {
  position: relative;
}
.benefits-image {
  width: 100%;
  height: 500px;
  object-fit: cover;
  border-radius: 25px;
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.15);
}
.support-section {
  padding: 100px 40px;
  background:
    linear-gradient(
      180deg,
      #ffffff 0%,
      #f0f9ff 100%);
  position: relative;
  overflow: hidden;
}
.support-container {
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}
.support-header {
  text-align: center;
  margin-bottom: 70px;
}
.support-title {
  font-size: 48px;
  font-weight: 800;
  color: #0f172a;
  margin-bottom: 20px;
  line-height: 1.2;
}
.support-title span {
  background:
    linear-gradient(
      135deg,
      #0077b6 0%,
      #00b4d8 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.support-subtitle {
  font-size: 18px;
  color: #64748b;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}
.support-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
  margin-bottom: 60px;
}
.support-features {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.feature-item {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: 25px;
  background: white;
  border-radius: 16px;
  border: 2px solid #e2e8f0;
  transition: all 0.3s ease;
}
.feature-item:hover {
  transform: translateX(8px);
  border-color: #0077b6;
  box-shadow: 0 10px 30px rgba(0, 119, 182, 0.1);
}
.feature-icon {
  width: 50px;
  height: 50px;
  min-width: 50px;
  background:
    linear-gradient(
      135deg,
      #0077b6 0%,
      #00b4d8 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0, 119, 182, 0.25);
}
.feature-icon svg {
  width: 24px;
  height: 24px;
  stroke: white;
}
.feature-text {
  flex: 1;
}
.feature-text h4 {
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 6px;
}
.feature-text p {
  font-size: 15px;
  color: #64748b;
  line-height: 1.6;
}
.support-visual {
  position: relative;
}
.visual-card {
  background:
    linear-gradient(
      135deg,
      #0077b6 0%,
      #00b4d8 100%);
  padding: 50px;
  border-radius: 30px;
  text-align: center;
  box-shadow: 0 30px 60px rgba(0, 119, 182, 0.3);
  position: relative;
  overflow: hidden;
}
.visual-icon {
  width: 100px;
  height: 100px;
  background: white;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 30px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  position: relative;
  z-index: 1;
}
.visual-icon svg {
  width: 50px;
  height: 50px;
  stroke: #0077b6;
}
.visual-title {
  font-size: 32px;
  font-weight: 800;
  color: white;
  margin-bottom: 15px;
  position: relative;
  z-index: 1;
}
.visual-description {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.95);
  line-height: 1.6;
  position: relative;
  z-index: 1;
  margin-bottom: 35px;
}
.visual-stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  margin-top: 35px;
  position: relative;
  z-index: 1;
}
.stat-item {
  text-align: center;
}
.stat-number {
  font-size: 32px;
  font-weight: 800;
  color: white;
  display: block;
  margin-bottom: 5px;
}
.stat-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.85);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.cta-button2 {
  display: inline-block;
  padding: 16px 40px;
  background: white;
  color: #0077b6;
  font-size: 16px;
  font-weight: 700;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.3s ease;
  margin-top: 30px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
  text-align: center;
}
.cta-button2:hover {
  transform: translateY(-3px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.25);
  background: #f0f9ff;
}
.ofr-cal-btn {
  border: solid;
  background: white;
  color: #0077b6;
  margin-top: 20px;
}
.reset-btn {
  width: 250px;
  background-color: #007ba7;
  color: white;
  border: none;
  border-radius: 20px;
  padding: 8px 18px;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.reset-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(253, 241, 13, 0.4);
}
.mtc-title {
  font-weight: 800;
  text-align: center;
  margin: 8px 0 24px;
  color: #0f172a;
  font-size: 32px;
}
.mock-calendar {
  --toolbar: #ffbf00;
  --toolbar-dark: #007ba7;
  --online: #fb923c;
  --ff: #007ba7;
  --book: #ffbf00;
  --book-dark: #007ba7;
  --card-border: #dbeafe;
  --card-hover: #1d4ed8;
}
.mock-calendar .toolbar {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--toolbar);
  padding: 20px;
  border-radius: 12px;
  margin: 0 8px 24px;
}
.search-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  width: 50%;
}
.mock-calendar .search-input {
  border: none;
  background: #fff;
  border-radius: 999px;
  padding: 10px 14px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08) inset;
  font-weight: 600;
  width: 100%;
}
.flt-text {
  font-size: 22px;
  font-weight: 600;
  color: #333;
  margin: 0 0 12px;
}
.mock-calendar .toolbar .toolbar-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
}
.mock-calendar .toolbar .toolbar-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
}
.mock-calendar .toolbar .toolbar-item label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #333;
  margin: 0;
  text-align: center;
}
.mock-calendar .toolbar .dropdown-like {
  width: 250px;
  position: relative;
}
.mock-calendar .toolbar .dropdown-like .form-select,
.mock-calendar .toolbar .dropdown-like select {
  appearance: none;
  border: none;
  background: #fff;
  border-radius: 20px;
  padding: 8px 28px 8px 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  font-weight: 600;
  font-size: 13px;
  width: 100%;
  cursor: pointer;
}
.mock-calendar .toolbar .dropdown-like .chev {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  pointer-events: none;
  color: #666;
}
.list-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.mock-calendar .session-card {
  width: 80%;
  background: #fff;
  border-radius: 12px;
  padding: 16px 20px;
  margin-top: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: auto 1fr auto auto auto;
  align-items: center;
  gap: 16px;
  transition: all 0.2s ease;
}
.mock-calendar .list-body .session-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}
.mock-calendar .list-body .session-card .date-chip {
  background: #0a84ae;
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: 800;
  font-size: 14px;
  white-space: nowrap;
  min-width: 100px;
  text-align: center;
}
.mock-calendar .list-body .session-card .date-chip.range {
  background: #f59e0b;
}
.mock-calendar .list-body .session-card .date-chip span {
  color: inherit;
  background: none;
  padding: 0;
  border-radius: 0;
  font-weight: inherit;
}
.mock-calendar .list-body .session-card .session-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.mock-calendar .list-body .session-card .session-title {
  font-weight: 700;
  color: #1e40af;
  text-decoration: none;
  font-size: 16px;
}
.mock-calendar .list-body .session-card .session-subtitle {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  text-decoration: none;
}
.mock-calendar .list-body .session-card .session-pattern {
  font-size: 18px;
  font-weight: 600;
  color: #6b7280;
}
.mock-calendar .list-body .session-card .badges {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}
.mock-calendar .list-body .session-card .badges .badge {
  font-size: 12px;
  font-weight: 600;
  padding: 4px 12px;
  border-radius: 16px;
  color: #fff;
}
.mock-calendar .list-body .session-card .badges .badge-online {
  background: var(--online);
}
.mock-calendar .list-body .session-card .badges .badge-ff {
  background: var(--ff);
}
.mock-calendar .list-body .session-card .badges .location-badge {
  background: #007ba7;
  color: #ffffff;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 4px;
}
.mock-calendar .list-body .session-card .badges .location-badge img {
  width: 14px;
  height: 14px;
}
.mock-calendar .list-body .session-card .badges .location-badge .truncate {
  max-width: 120px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mock-calendar .list-body .session-card .price {
  font-weight: 800;
  font-size: 16px;
  color: #0f172a;
  min-width: 80px;
  align-self: center;
}
.mock-calendar .list-body .session-card .action .btn-book,
.mock-calendar .btn-book {
  width: 200px;
  background: var(--book);
  color: #020202;
  border-radius: 20px;
  padding: 10px 24px;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  transition: background 0.2s ease;
  min-width: 80px;
  border: none;
  cursor: pointer;
}
.mock-calendar .btn-book:hover {
  background: var(--book-dark);
}
.mock-calendar .btn-load {
  background: var(--toolbar-dark);
  color: #111827;
  border-radius: 20px;
  padding: 12px 24px;
  font-weight: 800;
  border: none;
  cursor: pointer;
  font-size: 14px;
}
.mock-calendar .btn-load:hover {
  background: #d69e00;
}
.location-badge {
  background: #007ba7;
}
.hidden {
  display: none;
}
.af-ts {
  display: flex;
  justify-content: center;
  align-items: center;
}
.af-ts h3 {
  font-size: 32px;
  text-align: center;
  margin-right: 25px;
  margin-left: 25px;
  margin-top: 80px;
}
.faq-sc {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.faq-sc h4 {
  margin-top: 50px;
  font-weight: bold;
  font-size: 42px;
}
.drop-d {
  width: 50%;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  border: 1px solid #000000;
}
details {
  border: 0.5px solid #000000;
  overflow: hidden;
  width: 100%;
}
summary {
  padding: 10px 15px;
  cursor: pointer;
  font-weight: bold;
  width: 100%;
  border-radius: 0;
  border: 0.5px solid #000000;
  list-style: none;
  font-size: 16px;
}
details[open] summary {
  background: #e0e0e0;
}
details div {
  padding: 15px;
  background: #fff;
}
summary::before {
  content: "\25bc    ";
  font-size: 14px;
  transition: transform 0.3s ease;
  margin-left: 10px;
}
details[open] summary::after {
  transform: rotate(180deg);
}
details div {
  padding: 0 15px;
  background: #fff;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transform: scaleY(0);
  transform-origin: top;
  transition:
    transform 0.4s ease-in-out,
    opacity 0.3s ease-in-out,
    height 0.4s ease-in-out;
}
details[open] div {
  opacity: 1;
  height: auto;
  transform: scaleY(1);
  padding: 15px;
}
a {
  color: red;
  text-decoration: none;
}
.so-sc {
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 25px;
}
.so-sc img {
  width: 30px;
  height: 30px;
}
.offers-btn {
  background:
    linear-gradient(
      45deg,
      #ff6b35,
      #f7931e);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 20px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(255, 107, 53, 0.3);
}
.offers-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 107, 53, 0.4);
}
.blinking {
  animation: blink 2s infinite;
}
@keyframes blink {
  0%, 50% {
    opacity: 1;
    transform: scale(1);
  }
  25% {
    opacity: 0.8;
    transform: scale(1.05);
  }
  75% {
    opacity: 0.9;
    transform: scale(0.98);
  }
}
.offers-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  animation: fadeIn 0.3s ease;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.offers-popup-content {
  background: white;
  border-radius: 20px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  animation: slideUp 0.4s ease;
}
@keyframes slideUp {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
.offers-popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 25px 30px;
  border-bottom: 1px solid #eee;
  background:
    linear-gradient(
      135deg,
      #f8f9fa,
      #e9ecef);
  border-radius: 20px 20px 0 0;
}
.offers-popup-header h2 {
  margin: 0;
  font-size: 28px;
  font-weight: bold;
  color: #333;
}
.offers-close-btn {
  background: none;
  border: none;
  font-size: 32px;
  color: #666;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.3s ease;
}
.offers-close-btn:hover {
  background-color: #f1f3f4;
  color: #333;
}
.offers-list {
  padding: 20px 30px;
}
.offer-item {
  display: flex;
  align-items: flex-start;
  padding: 15px 0;
  border-bottom: 1px solid #f0f0f0;
}
.offer-item:last-child {
  border-bottom: none;
}
.offer-icon {
  font-size: 24px;
  margin-right: 15px;
  color: #ff6b35;
  flex-shrink: 0;
}
.offer-text {
  font-size: 18px;
  line-height: 1.5;
  color: #4a5568;
  font-weight: 500;
}
.offers-popup-footer {
  padding: 20px 30px;
  background-color: #f8f9fa;
  border-radius: 0 0 20px 20px;
  text-align: center;
}
.offers-popup-footer p {
  margin: 0;
  font-size: 14px;
  color: #666;
  font-style: italic;
}
.purchase-popup {
  position: fixed;
  left: 25px;
  bottom: 25px;
  z-index: 9999;
  background: #fff;
  padding: 15px 25px;
  border-radius: 16px;
  box-shadow: 0 6px 35px rgba(41, 64, 85, 0.13), 0 1.5px 15px rgba(41, 64, 85, 0.1);
  font-size: 1.14rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #232323;
  min-width: 275px;
  max-width: 90vw;
  animation: slidein-popup 0.54s cubic-bezier(0.4, 0.97, 0.65, 1.01);
}
.popup-user {
  font-weight: 700;
  color: #ffa340;
}
.popup-action {
  color: #5044e6;
  font-weight: 500;
}
.popup-course {
  background: #ffebd1;
  color: #ed6823;
  font-weight: bolder;
  border-radius: 8px;
  padding: 2px 10px;
  margin-left: 7px;
  font-size: 1.12rem;
}
@keyframes slidein-popup {
  0% {
    opacity: 0;
    transform: translateY(60px) scale(0.95);
  }
  58% {
    opacity: 1;
    transform: translateY(-8px) scale(1.03);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.popup-overlay {
  position: fixed;
  z-index: 3000;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}
.popup-card {
  position: relative;
  width: 410px;
  max-width: 92vw;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 6px 45px rgba(0, 0, 0, 0.14);
  background: transparent;
  animation: popmodal 0.4s cubic-bezier(0.54, 1.4, 0.45, 1);
}
@keyframes popmodal {
  from {
    transform: scale(0.92);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.popup-close {
  position: absolute;
  top: 16px;
  right: 18px;
  background: none;
  border: none;
  color: #ff671b;
  font-size: 2rem;
  cursor: pointer;
  z-index: 3;
  font-weight: 600;
  line-height: 1;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  transition: background 0.13s;
}
.popup-close:hover {
  background: #fff6f1;
}
.popup-full-link {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
}
.carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  max-width: 960px;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
}
.carousel-container {
  width: 70%;
  overflow: hidden;
  position: relative;
}
.carousel-track {
  display: flex;
  transition: transform 0.5s ease-in-out;
}
.slide {
  min-width: 100%;
  padding: 10px;
  box-sizing: border-box;
}
.slide img {
  width: 100%;
  height: auto;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}
.nav-button {
  background-color: orange;
  border: none;
  color: white;
  font-size: 24px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  z-index: 2;
}
.test-date-highlight {
  background: #42a5f5 !important;
  color: #fff !important;
  border-radius: 50%;
  font-weight: bold;
}
.top-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
.mock-test-wrapper .offers-btntop {
  width: 250px;
  margin-top: 20px;
  padding: 12px 24px;
  background-color: #1dad00;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(89, 255, 64, 0.3);
}
.title {
  color: #ffffff;
  font-size: 60px;
  font-weight: bold;
  text-align: right;
  margin-bottom: 20px;
}
.subtitle {
  font-size: 32px;
  margin-top: 10px;
  text-align: right;
  color: white;
  margin-bottom: 20px;
}
.modes {
  font-weight: bold;
  margin-top: 10px;
  text-align: right;
  color: white;
  margin-bottom: 20px;
}
.highlight {
  margin-top: 20px;
  font-size: 24px;
  font-weight: bold;
  text-align: right;
  color: white;
}
.left p {
  font-size: 18px;
  text-align: right;
  color: white;
}
.highlight .orange {
  color: #f37021;
}
.calendar-btn {
  width: 250px;
  margin-top: 20px;
  padding: 12px 24px;
  background-color: #f37021;
  color: white;
  border: none;
  border-radius: 20px;
  font-size: 18px;
  cursor: pointer;
}
.right {
  width: 45%;
  display: flex;
  justify-content: center;
}
.target-image {
  width: 100%;
}
.cal-inst {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}
.cal-inst h1 {
  font-weight: bold;
}
.cal-inst h2 {
  font-size: 24px;
}
.co-sc {
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
  align-items: center;
}
.co-sc h4 {
  margin-top: 80px;
  text-align: center;
}
.co-sc h4 span {
  color: #f38d19;
  font-weight: bold;
}
.card-ts {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 22px;
  width: 380px;
  height: 250px;
  background-color: white;
  margin-top: 50px;
  margin-left: 25px;
  margin-right: 25px;
  margin-bottom: 50px;
  padding: 10px;
}
.ts-sc {
  display: flex;
}
.ft-sc {
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  background-color: #fcfcfc;
  align-items: center;
  background-image: url(/assets/images/ft-bg.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-attachment: fixed;
  height: 100vh;
}
.ft-sc-title {
  font-weight: 600;
  margin: 35px;
  color: rgb(30, 30, 30);
  font-size: 36px;
}
.ft-sc-info {
  display: flex;
  width: 100%;
  justify-content: space-between;
  gap: 20px;
}
.ft-sc-item {
  width: 350px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
  padding: 20px;
  justify-content: center;
  align-items: flex-start;
  margin-top: 50px;
  margin-bottom: 50px;
}
.ft-sc-item img {
  width: 75px;
}
.left {
  margin-left: 100px;
}
.right {
  margin-right: 100px;
}
.ft-sc-item h3 {
  color: #ed6823;
  font-size: 22px;
}
.ft-sc p {
  font-size: 18px;
}
@media (max-width: 1024px) {
  .hero-title {
    font-size: 42px;
  }
  .support-content,
  .benefits-container {
    grid-template-columns: 1fr;
    gap: 50px;
  }
  .support-title {
    font-size: 40px;
  }
  .centers-grid {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}
@media (max-width: 991.98px) {
  .mock-calendar .toolbar .toolbar-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .mock-calendar .toolbar .toolbar-item {
    min-width: 200px;
  }
  .mock-calendar .list-body .session-card {
    grid-template-columns: 1fr;
    gap: 12px;
    text-align: center;
  }
  .mock-calendar .list-body .session-card .session-info {
    align-items: center;
  }
  .mock-calendar .list-body .session-card .badges {
    justify-content: center;
  }
}
@media (max-width: 768px) {
  .hero-section {
    margin-top: 70px;
    padding: 40px 15px;
    min-height: auto;
  }
  .hero-container {
    gap: 40px;
  }
  .hero-title {
    font-size: 32px;
    margin-bottom: 20px;
  }
  .hero-subtitle {
    font-size: 14px;
    padding: 0 10px;
  }
  .exam-badge {
    font-size: 14px;
    padding: 10px 18px;
    letter-spacing: 1px;
  }
  .mode-tag {
    font-size: 12px;
    padding: 8px 16px;
  }
  .hero-ctas {
    flex-direction: column;
    width: 100%;
    padding: 10px;
  }
  .cta-button {
    width: 100%;
    padding: 12px 30px;
    font-size: 16px;
    margin: 5px 0;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
  .offers-strip {
    flex-direction: column;
    gap: 10px;
    text-align: center;
    padding: 15px;
  }
  .offers-text {
    font-size: 14px;
  }
  .strong {
    font-size: 16px;
  }
  .offers-claim-btn {
    width: 100%;
    max-width: 200px;
  }
  .centers-section {
    padding: 20px 10px;
  }
  .centers-grid {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 10px;
  }
  .center-card {
    max-width: 100%;
    height: 110px;
  }
  .center-name {
    font-size: 16px;
  }
  .center-exams {
    font-size: 12px;
    text-align: center;
  }
  .mock-categories {
    padding: 40px 10px;
  }
  .mock-categories h3 {
    font-size: 28px;
    margin-bottom: 30px;
  }
  .test-cards-wrapper {
    grid-template-columns: 1fr;
    gap: 20px;
    padding: 0 10px;
  }
  .exam-card {
    padding: 25px 20px;
  }
  .exam-title {
    font-size: 24px;
  }
  .exam-info-row {
    font-size: 14px;
  }
  .delivery-badge {
    font-size: 12px;
  }
  .action-btn {
    padding: 12px 20px;
    font-size: 14px;
  }
  .benefits-section,
  .support-section {
    padding: 60px 20px;
  }
  .benefits-content h2 {
    font-size: 28px;
  }
  .benefits-subtitle {
    font-size: 14px;
  }
  .benefits-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  .benefit-card {
    padding: 20px;
  }
  .benefit-icon {
    width: 40px;
    height: 40px;
    min-width: 40px;
  }
  .benefit-text {
    font-size: 14px;
  }
  .benefits-image {
    height: 350px;
  }
  .support-title {
    font-size: 28px;
  }
  .support-subtitle {
    font-size: 16px;
  }
  .feature-item {
    padding: 20px;
  }
  .feature-icon {
    width: 45px;
    height: 45px;
    min-width: 45px;
  }
  .feature-text h4 {
    font-size: 16px;
  }
  .feature-text p {
    font-size: 14px;
  }
  .visual-card {
    padding: 35px 25px;
  }
  .visual-title {
    font-size: 24px;
  }
  .visual-description {
    font-size: 14px;
  }
  .visual-stats {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .stat-number {
    font-size: 28px;
  }
  .cta-button2 {
    padding: 14px 30px;
    font-size: 15px;
  }
  .ofr-cal-btn {
    border: solid;
    width: 100%;
    background: white;
    color: #0077b6;
    margin-top: 10px;
    align-self: center;
    border-radius: 999px;
    padding: 10px;
  }
  .top-buttons {
    flex-direction: column;
    width: 100%;
  }
  .title {
    font-size: 24px;
    margin: 5px;
  }
  .subtitle {
    font-size: 24px;
    text-align: center;
    margin-bottom: 15px;
  }
  .modes {
    font-size: 16px;
    text-align: center;
    margin-bottom: 30px;
  }
  .calendar-btn {
    width: 80%;
    margin-left: 0;
    font-size: 18px;
    padding: 15px 20px;
    border-radius: 15px;
    margin-top: 10px;
  }
  .cal-inst h1 {
    font-weight: bold;
    font-size: 28px;
    text-align: center;
  }
  .cal-inst h2 {
    font-size: 18px;
    text-align: center;
  }
  .ft-sc-info {
    flex-direction: column;
    align-items: center;
  }
  .ft-sc {
    height: 100%;
  }
  .ft-sc-item {
    width: 250px;
    height: 200px;
    margin-bottom: 10px;
    margin-top: 10px;
  }
  .ft-sc-item img {
    margin: 5px;
    width: 45px;
  }
  .ft-sc-item h3 {
    font-size: 18px;
    line-height: 20px;
  }
  .ft-sc p {
    font-size: 14px;
  }
  .co-sc h1 {
    margin-top: 25px;
    font-size: 22px;
  }
  .ts-sc {
    flex-direction: column;
  }
  .card-ts {
    width: 300px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .card-ts h4 {
    font-size: 16px;
  }
  .card-ts p {
    font-size: 12px;
  }
  .faq-sc h1 {
    margin-top: 25px;
    font-size: 36px;
  }
  .drop-d {
    width: 90%;
  }
  .faq-sc h3 {
    font-size: 18px;
    line-height: 25px;
  }
  .left {
    margin-left: 0;
  }
  .right {
    margin-right: 0;
  }
  .mock-calendar .toolbar .toolbar-row {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }
  .toolbar-item {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .dropdown-like {
    max-width: 150px;
  }
  .mock-calendar .list-body .session-card .session-pattern {
    font-size: 14px;
  }
  .reset-btn {
    width: 150px;
    background-color: #007ba7;
    color: white;
    border: none;
    border-radius: 30px;
    padding: 5px 10px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .search-item {
    width: 90%;
  }
  .purchase-popup {
    left: 5vw;
    bottom: 14vw;
    padding: 9px 10px;
    min-width: 130px;
    font-size: 0.92rem;
  }
  .popup-course {
    font-size: 0.97rem;
  }
  .download-btns-wrapper {
    flex-direction: column;
    gap: 15px;
    align-items: center;
  }
  .offers-btn {
    width: 70%;
    padding: 15px 20px;
    font-size: 16px;
  }
  .offers-popup-content {
    width: 95%;
    margin: 10px;
  }
  .offers-popup-header {
    padding: 20px;
  }
  .offers-popup-header h2 {
    font-size: 24px;
  }
  .offers-list {
    padding: 15px 20px;
  }
  .offer-text {
    font-size: 16px;
  }
  .offers-popup-footer {
    padding: 15px 20px;
  }
  .offer-cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
    width: 100%;
    padding: 10px;
    margin-top: 20px;
  }
  .offer-cards img {
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  .offer-section {
    padding: 15px;
  }
  .offer-section h1 {
    font-size: 22px;
    margin-bottom: 15px;
  }
  .banner-img {
    width: 100%;
    padding: 0 5px;
  }
}
@media (max-width: 575.98px) {
  .mock-calendar .toolbar .toolbar-row {
    grid-template-columns: 1fr;
  }
  .ofr-cal-btn {
    border: solid;
    width: 100%;
    background: white;
    color: #0077b6;
    margin-top: 10px;
    align-self: center;
    border-radius: 999px;
    padding: 10px;
  }
}
@media (max-width: 480px) {
  .hero-title {
    font-size: 26px;
  }
  .hero-subtitle {
    font-size: 13px;
  }
  .mock-categories h3 {
    font-size: 24px;
  }
  .exam-title {
    font-size: 20px;
  }
  .benefits-content h2 {
    font-size: 24px;
  }
  .support-title {
    font-size: 24px;
  }
  .center-card {
    height: 100px;
  }
  .center-name {
    font-size: 15px;
  }
  .center-exams {
    font-size: 12px;
  }
}
.ofr-cal-btn {
  width: 100%;
  border: solid;
  background: white;
  color: #0077b6;
  margin-top: 20px;
  font-weight: 600;
  border-radius: 999px;
  padding: 10px;
}
/*# sourceMappingURL=year-four-cal.component.css.map */
